module.exports = __webpack_public_path__ + "img/image_5.4d0ece9b.jpg";